export default __webpack_public_path__ + "navigation-examples-route-init-thumbnail-v1-960-17a6e806ce4e1031fcae7321845b0e40.webp";